import type { IGetOfficeConsentContentParameters } from '../../types/OfficeConsentContent.parameters';

export const factoryGetOfficeConsentContentKey = (params: IGetOfficeConsentContentParameters) => {
  return ['GET_OFFICE_CONSENT_CONTENT', params.officeId, params.code] as const;
};
